// eslint-disable-next-line import/no-unresolved
import { parse } from 'csv-parse/browser/esm/sync';
import { readTextFromBlob } from 'src/components/file-preview/txt';
import { appI18n } from '@flowus/common/i18n';
import { Regex } from '.';

export interface Guest {
  name: string;
  contact: string;
}
const MAX_LINE_COUNT = 2000;
const FILE_LIMIT_SIZE = 3 * 1024 * 1024; // 3M
/** 读取外来协作者名单 */
export const readGuestListFromFile = async (file: File): Promise<Guest[]> => {
  if (file.size > FILE_LIMIT_SIZE) {
    throw Error(appI18n.t('common.file_size_limit') as string);
  }

  if (file.name.endsWith('.txt')) {
    const text = await readTextFromBlob(file);
    if (typeof text === 'string') {
      return readGuestListFromTxt(text);
    }
  } else if (file.name.endsWith('.csv')) {
    const text = await readTextFromBlob(file);
    if (typeof text === 'string') {
      return readGuestListFromCsv(text);
    }
  }
  return [];
};
/** 解析csv文本,如果手机号码相同，则默认后面覆盖前面的 */
const readGuestListFromCsv = (text: string) => {
  let result;
  try {
    result = parse(text);
  } catch {
    throw Error(appI18n.t('utils.importGuest.csvFormatError') as string);
  }
  const guests: Map<string, string> = new Map<string, string>();
  if (result instanceof Array) {
    if (result.length > MAX_LINE_COUNT) {
      throw Error(
        appI18n.t('utils.importGuest.csvLineLimitError', { maxLines: MAX_LINE_COUNT }) as string
      );
    }
    result.forEach((r, index) => {
      if (r instanceof Array && r.length === 2) {
        const name = r[0];
        const contact = r[1];
        if (!name || !contact) {
          throw Error(appI18n.t('utils.importGuest.csvFormatError') as string);
        }

        if (!__BUILD_IN__) {
          if (!Regex.Mobile.test(contact)) {
            throw new Error(`${index + 1}, [${r.join(',')}]`);
          }
        } else {
          if (!Regex.Email.test(contact)) {
            throw new Error(`${index + 1}, [${r.join(',')}]`);
          }
        }

        guests.set(contact, name);
      } else {
        throw Error(appI18n.t('utils.importGuest.csvFormatError') as string);
      }
    });

    const obj = Array.from(guests, ([contact, name]) => {
      return { contact, name } as Guest;
    });
    return obj;
  }
  throw Error(appI18n.t('utils.importGuest.csvFormatError') as string);
};
/** 解析txt文本，如果手机号码相同，则默认后面覆盖前面的 */
const readGuestListFromTxt = (text: string) => {
  let lines = text.split(/[\r\n]+/g);
  lines = lines.filter((l) => l.trim()); // 过滤掉空行
  const guests: Map<string, string> = new Map<string, string>();
  if (lines.length > MAX_LINE_COUNT) {
    throw Error(
      appI18n.t('utils.importGuest.txtLineLimitError', { maxLines: MAX_LINE_COUNT }) as string
    );
  }
  lines.forEach((line, index) => {
    const strArr = line.split(',');
    if (strArr.length !== 2) {
      throw new Error(`${index + 1}, [${line}]`);
    }
    const name = strArr[0];
    const contact = strArr[1];
    if (!name || !contact) {
      throw new Error(`${index + 1}, [${line}]`);
    }
    if (__BUILD_IN__) {
      if (!Regex.Email.test(contact)) {
        throw new Error(`${index + 1}, [${line}]`);
      }
    } else {
      if (!Regex.Mobile.test(contact)) {
        throw new Error(`${index + 1}, [${line}]`);
      }
    }
    guests.set(contact, name);
  });
  const obj = Array.from(guests, ([contact, name]) => {
    return { contact, name } as Guest;
  });
  return obj;
};
